import auth from "@/auth";
import { Department } from "@/constant/Department";
import { UserRoles } from "@/constant/UserRoles";
import router from "@/router/router";
import { User } from "oidc-client-ts";
import { defineStore, acceptHMRUpdate } from "pinia";
import { useAudit } from "@/stores/audit";
import { jwtDecode } from "jwt-decode";
import { ref } from 'vue';


export const useAuthenticationStore = defineStore("authentication", {
  
  state: () => ({
    user: null as User | null,
    // default is level 0
    role: "",
    department: "",
    userRole: 4 as number,
    token :"" as any ,
    profile_name : "" as any ,
    profile_email : "" as any ,
    profile_preferred_username : "" as any ,
    group : "" as any
  }),

  getters: {
    isUserValid(): boolean {
      return this.user != null && !this.user.expired;
    },
    getUserDisplayName(): string | undefined {
      return (
        this.user?.profile.preferred_username ||
        this.user?.profile.name ||
        this.user?.profile.email 
      );
    },
  },
  actions: {
    setUser(user: User | null) {
      this.user = user;
    },
    decodeJwt(){
      // get token and decode 
     this.token = this.user?.access_token;
     const decoded:any= jwtDecode(this.token);

     // after decode  set Department
     if (decoded.groups.includes(Department.RM)) {
      this.department = "RM";
    } else if (decoded.groups.includes(Department.AS)) {
      this.department = "AS";
    } else if (decoded.groups.includes(Department.AV)) {
      this.department = "AV";
    }
     // after decoden set userrole
    //  if (
    //   decoded.groups.includes(UserRoles.ARCHIVIST) &&
    //   decoded.groups.includes(UserRoles.OFFICER) &&
    //   decoded.groups.includes(UserRoles.ADMINISTRATOR)
    // ) {
    //   this.userRole = 0;
    //   this.role = "Super Admin";
    // } else if (decoded.groups.includes(UserRoles.ARCHIVIST)) {
    //   this.userRole = 3;
    //   this.role = "Archivist";
    // } else if (decoded.groups.includes(UserRoles.OFFICER)) {
    //   this.userRole = 2;
    //   this.role = "Officer";
    // } else if (decoded.groups.includes(UserRoles.ADMINISTRATOR)) {
    //   this.userRole = 1;
    //   this.role = "Administrator";
    // }



const isAdmin = decoded.groups.includes(UserRoles.ADMINISTRATOR);
const isOfficer = decoded.groups.includes(UserRoles.OFFICER);
const isArchivist = decoded.groups.includes(UserRoles.ARCHIVIST);

// All roles
if (isAdmin && isOfficer && isArchivist) {
  this.userRole = 0;
  this.role = "Super Admin";
}
// Admin + Archivist
else if (isAdmin && isArchivist) {
  this.userRole = 5;
  this.role = "Archivist + Administrator";
}
// Single roles
else if (isArchivist) {
  this.userRole = 3;
  this.role = "Archivist";
}
else if (isOfficer) {
  this.userRole = 2;
  this.role = "Officer";
}
else if (isAdmin) {
  this.userRole = 1;
  this.role = "Administrator";
}
    //
      this.profile_name = decoded.name;
 },
    // setRoles(groups) {
    //   if (groups.includes(Department.RM)) {
    //     this.department = "RM";
    //   } else if (groups.includes(Department.AS)) {
    //     this.department = "AS";
    //   } else if (groups.includes(Department.AV)) {
    //     this.department = "AV";
    //   }
    //   if (
    //     groups.includes(UserRoles.ARCHIVIST) &&
    //     groups.includes(UserRoles.OFFICER) &&
    //     groups.includes(UserRoles.ADMINISTRATOR)
    //   ) {
    //     this.userRole = 0;
    //     this.role = "Super Admin";
    //   } else if (groups.includes(UserRoles.ARCHIVIST)) {
    //     this.userRole = 3;
    //     this.role = "Archivist";
    //   } else if (groups.includes(UserRoles.OFFICER)) {
    //     this.userRole = 2;
    //     this.role = "Officer";
    //   } else if (groups.includes(UserRoles.ADMINISTRATOR)) {
    //     this.userRole = 1;
    //     this.role = "Administrator";
    //   }
    // },
    removeUser() {
      // const isSessionEmpty = ref(false);
      const audit = useAudit();
      audit.auditLog("Logout")
      // Dex doesn't allow to end sessions upstream:
      // https://github.com/dexidp/dex/issues/1697.
      auth.removeUser().then(() => {
        this.user = null;
        this.department = "";
        this.userRole = 4;
        this.role = "";
        sessionStorage.clear();
        localStorage.clear();
        // isSessionEmpty.value = Object.keys(localStorage).length === 0;

                      setTimeout(() => {
                router.push({ name: "login" });
              }, 500);

            
            // if (isSessionEmpty.value) {
            //   setTimeout(() => {
            //     router.push({ name: "login" });
            //   }, 500);
            // } else {
            //   sessionStorage.clear();
            //   localStorage.clear();
            //   setTimeout(() => {
            //     router.push({ name: "login" });
            //   }, 500);
            // }

      });
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useAuthenticationStore, import.meta.hot)
  );
}
